module.exports = __webpack_public_path__ + "img/252.8db1c49d.jpg";